import React from 'react'
import { Link, useNavigate, useParams } from "react-router-dom";
import MainButton from '../components/MainButton';
import {MenuIcon,XIcon,ChevronUpIcon,ChevronDownIcon} from '@heroicons/react/solid'
import DropdownNav from 'components/DropdownNav';
import cx from 'classnames';
import Disclosour from 'components/Disclosour';
import { Transition } from "@headlessui/react"
import ModalLogin from 'components/ModalLogin';


export default function Navbar({active,landing}) {
  const {slug} = useParams()

  const [isOpen, setIsOpen] = React.useState(false);
  const [isDrop,setIsDrop] = React.useState(true);
  const [isDrop2,setIsDrop2] = React.useState(true);
  // const [scroll,setScroll] = React.useState(false);

  const navigate = useNavigate();


  const mobileNav = cx({
    "z-10 fixed transition duration-300 overflow-hidden items-center flex flex-col space-y-5 font-semibold min-h-full min-w-full nav-wrapper xl:hidden mt-[58px] py-5 px-5 bg-white": true,
  });

  const activeNav = cx({
    "text-secondary nav-links": active === "kegiatan" || "berita" || "dokumen" || "home",
  });

  return (
    <>
      <div className={landing ? "hidden" : ""}>
        <header
          className="fixed z-10 flex items-center justify-between w-full px-5 py-5 bg-white xl:px-99"
          id="navbar"
        >
          <div className="font-bold transition-all duration-300 logo hover:text-gray-600">
            <Link to={`/${slug}`}>Geulanggang-Panah</Link>
          </div>
          <div className="menuWrapper xl:hidden">
            {!isOpen ? (
              <MenuIcon
                className={
                  !isOpen
                    ? "w-6 h-6 transition-all duration-300 hover:text-gray-600 hover:cursor-pointer block"
                    : "hidden"
                }
                onClick={() => setIsOpen(!isOpen)}
              />
            ) : (
              <XIcon
                className={
                  isOpen
                    ? "w-6 h-6 transition-all duration-300 hover:text-gray-600 hover:cursor-pointer"
                    : "hidden"
                }
                onClick={() => setIsOpen(!isOpen)}
              />
            )}
          </div>
          <div className="items-center hidden space-x-8 font-medium xl:flex nav-links-wrapper">
            <div className={active === "home" ? activeNav : "nav-links"}>
              <Link to={`/${slug}`}>Home</Link>
            </div>
            <div
              className="flex items-center cursor-pointer nav-links"
              onClick={() => {
                setIsDrop(!isDrop);
                setIsDrop2(true);
              }}
            >
              Profil Gampong
              {isDrop ? (
                <ChevronDownIcon className="w-4 h-4 " />
              ) : (
                <ChevronUpIcon className="w-4 h-4 " />
              )}
            </div>
            <div
              className="flex items-center cursor-pointer nav-links"
              onClick={() => {
                setIsDrop2(!isDrop2);
                setIsDrop(true);
              }}
            >
              Informasi Gampong
              {isDrop2 ? (
                <ChevronDownIcon className="w-4 h-4 " />
              ) : (
                <ChevronUpIcon className="w-4 h-4 " />
              )}
            </div>
            <div className={active === "kegiatan" ? activeNav : "nav-links"}>
              <Link to={`/${slug}/kegiatan`}>Kegiatan</Link>
            </div>
            <div className={active === "berita" ? activeNav : "nav-links"}>
              <Link to={`/${slug}/berita`}>Berita</Link>
            </div>
            <div className={active === "dokumen" ? activeNav : "nav-links"}>
              <Link to={`/${slug}/documents`}>Dokumen</Link>
            </div>

            <div className="nav-links">
              <MainButton
                label="Layanan Masyarakat"
                onClick={() => navigate(`/${slug}/layanan`)}
              />
            </div>
          </div>
        </header>
        <DropdownNav hide={isDrop}>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/sejarah`}>Sejarah</Link>
          </div>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/pemerintahan`}>Pemerintahan</Link>
          </div>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/perangkat`}>Perangkat Gampong</Link>
          </div>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/visimisi`}>Visi Misi</Link>
          </div>
        </DropdownNav>

        <DropdownNav hide={isDrop2}>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/geografi`}>Greografi dan Demografi</Link>
          </div>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/sdm`}>SDM</Link>
          </div>
          <div className="hover:text-gray-200">
            <Link to={`/${slug}/sdg`}>Sumber Daya Gampong</Link>
          </div>
        </DropdownNav>
        <Transition
          show={isOpen}
          enter="transition-opacity duration-100"
          enterFrom="opacity-20"
          enterTo="opacity-100"
          leave="transition-opacity duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={isOpen ? `block ${mobileNav}` : "hidden"}>
            <Disclosour label="Profil Gampong">
              <div className="nav-links">
                <Link to={`/${slug}/sejarah`}>Sejarah</Link>
              </div>
              <div className="nav-links">
                <Link to={`/${slug}/pemerintahan`}>Pemerintahan</Link>
              </div>
              <div className="nav-links">
                <Link to={`/${slug}/perangkat`}>Perangkat Gampong</Link>
              </div>
              <div className="nav-links">
                <Link to={`/${slug}/visimisi`}>Visi Misi</Link>
              </div>
            </Disclosour>
            <Disclosour label="Informasi Gampong">
              <div className="nav-links">
                <Link to={`/${slug}/geografi`}>Greografi dan Demografi</Link>
              </div>
              <div className="nav-links">
                <Link to={`/${slug}/sdm`}>SDM</Link>
              </div>
              <div className="nav-links">
                <Link to={`/${slug}/sdg`}>Sumber Daya Gampong</Link>
              </div>
            </Disclosour>
            <div className="nav-links">
              <Link to={`/${slug}/kegiatan`}>Kegiatan</Link>
            </div>
            <div className="nav-links">
              <Link to={`/${slug}/berita`}>Berita</Link>
            </div>
            <div className="nav-links">
              <Link to={`/${slug}/documents`}>Dokumen</Link>
            </div>
            <div className="hover:text-gray-200">
              <Link to={`/${slug}/layanan`}>Layanan Masyarakat</Link>
            </div>
          </div>
        </Transition>
      </div>

      {/* NAV FOR LANDING */}

      <div className={landing ? "" : "hidden"}>
        <header
          className="fixed z-10 flex items-center justify-between w-full px-5 py-5 bg-transparent bg-white xl:px-99"
          id="navbar"
        >
          <div className="font-bold transition-all duration-300 logo hover:text-gray-600">
            <Link to="/">Geulanggang-Panah</Link>
          </div>
          <div className="menuWrapper xl:hidden">
            {!isOpen ? (
              <MenuIcon
                className={
                  !isOpen
                    ? "w-6 h-6 transition-all duration-300 hover:text-gray-600 hover:cursor-pointer block"
                    : "hidden"
                }
                onClick={() => setIsOpen(!isOpen)}
              />
            ) : (
              <XIcon
                className={
                  isOpen
                    ? "w-6 h-6 transition-all duration-300 hover:text-gray-600 hover:cursor-pointer"
                    : "hidden"
                }
                onClick={() => setIsOpen(!isOpen)}
              />
            )}
          </div>
          <div className="items-center hidden space-x-8 font-medium xl:flex nav-links-wrapper">
            <div className={active === "beranda" ? activeNav : "nav-links"}>
              <Link to="/">Beranda</Link>
            </div>
            <div className={active === "listdesa" ? activeNav : "nav-links"}>
              <Link to="/daftardesa">Daftar Desa</Link>
            </div>
            <div className={active === "register" ? activeNav : "nav-links"}>
              <Link to="/register">Registrasi Desa</Link>
            </div>
            <div className="hidden nav-links lg:block">
              <ModalLogin />
            </div>
          </div>
        </header>
        <Transition
          show={isOpen}
          enter="transition-opacity duration-100"
          enterFrom="opacity-20"
          enterTo="opacity-100"
          leave="transition-opacity duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={isOpen ? `block ${mobileNav}` : "hidden"}>
            <div className="nav-links">
              <Link to="/daftardesa">Daftar Desa</Link>
            </div>
            <div className="nav-links">
              <Link to="/register">Registrasi Desa</Link>
            </div>
            <div className="hover:text-gray-200">
              <ModalLogin />
            </div>
          </div>
        </Transition>
      </div>
    </>
  );
}
